import { __module as shim } from "../../../_virtual/index2.js";
import { __require as requireUseSyncExternalStoreShim_production } from "../cjs/use-sync-external-store-shim.production.js";
import { __require as requireUseSyncExternalStoreShim_development } from "../cjs/use-sync-external-store-shim.development.js";
var hasRequiredShim;
function requireShim() {
  if (hasRequiredShim) return shim.exports;
  hasRequiredShim = 1;
  if (process.env.NODE_ENV === "production") {
    shim.exports = requireUseSyncExternalStoreShim_production();
  } else {
    shim.exports = requireUseSyncExternalStoreShim_development();
  }
  return shim.exports;
}
export {
  requireShim as __require
};
//# sourceMappingURL=index.js.map
